export default "__VITE_ASSET__BaBRjMWH__"